import type { UserRole } from '@inou/shared';
import { createContext, type ReactNode, useContext } from 'react';

/**
 * いま見ている人のロール。
 *
 * 画面間のリンクは「相手の画面を開ける人にだけ見せる」ので、表の行の中まで
 * ロールが要る。工数明細のグリッドのように 3 階層下でも要るため、
 * prop で引き回さず AppLayout から配る。
 * 判定そのものは `lib/nav.ts` の `canOpen` に置く (ここは配るだけ)。
 */
const viewerRoleContext = createContext<UserRole | null>(null);

export function ViewerProvider({ role, children }: { role: UserRole; children: ReactNode }) {
  return <viewerRoleContext.Provider value={role}>{children}</viewerRoleContext.Provider>;
}

export function useViewerRole(): UserRole {
  const role = useContext(viewerRoleContext);
  if (role === null) throw new Error('ViewerProvider の外では useViewerRole を使えません');
  return role;
}
